import { UserPlusIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";
import Alert from "../Alert";
import LoadingSpinner from "../LoadingSpinner";
import MapEditorPerson from "./MapEditorPerson";
import { useGetPlotQuery } from "/src/redux/plotsApi";
import MapEditorPeopleOccupied from "./MapEditorPeopleOccupied";
import MapEditorDateEditor from "./MapEditorDateEditor";
import MapEditorPlotOwnerEditor from "./MapEditorPlotOwnerEditor";
import MapEditorPlotOccupantEditor from "./MapEditorPlotOccupantEditor";
import useAccessLevel from '/src/hooks/useAccessLevel';

const pTypes = {
    plotOwner: 'plotOwner',
    plotOccupant: 'plotOccupant',
}

export default function MapEditorPeople({plotId, onError}){
    const [editItem, setEditItem] = useState(null);
    const { data: details, error: queryError, isLoading } = useGetPlotQuery(plotId, {skip: !plotId});
    const [isOccupied, setIsOccupied] = useState(false);

    const plotOwners = details && details.plotOwners;
    const plotOccupants = details && details.plotOccupants;
    const dataSaysOccupied = (plotOwners && plotOwners.length) || (details && details.date);

    const canEditPlots = useAccessLevel('staff');
    const canEditOccupants = useAccessLevel('visitor');
    
    return (
        <div>
            {isLoading && <LoadingSpinner className='w-6' />}
            <h4 className='text-xl font-light mb-2'>{editItem?editItem._id?'Edit Person':'Add Person':'People'}</h4>
            <hr className="mb-4 border-black" />
            {(queryError && (
                <Alert className='border-t-red-600'>
                    <p>Couldn't find people for this plot</p>
                    <p>({queryError.message || queryError.data.message})</p>
                </Alert>
            )) || (editItem && (editItem._type == pTypes.plotOwner) && (
                <MapEditorPlotOwnerEditor _id={editItem._id} plotId={plotId} onSave={()=>setEditItem(null)} onDiscard={()=>setEditItem(null)} />
            )) || (editItem && (editItem._type == pTypes.plotOccupant) && (
                <MapEditorPlotOccupantEditor _id={editItem._id} plotId={plotId} onSave={()=>setEditItem(null)} onDiscard={()=>setEditItem(null)} />
            )) || (
                <div>
                    <h4 className='font-bold mb-4'>Occupants</h4>
                    <ul className="block">
                        {plotOccupants && plotOccupants.length > 0 && plotOccupants.map(item=>(
                            <li className="block mb-4" key={item._id}>
                                {(canEditOccupants && (
                                    <button className="btn-invert w-full p-4" onClick={()=>setEditItem({...item, _type: pTypes.plotOccupant})}>
                                        <MapEditorPerson _id={item._id} plotId={plotId} />
                                    </button>
                                )) || (
                                    <div className="w-full p-4">
                                        <MapEditorPerson _id={item._id} plotId={plotId} />
                                    </div>
                                )}
                            </li>
                        ))}
                        {(canEditOccupants && (
                            <li className="block mb-4">
                                <button className="btn flex w-full p-4" onClick={()=>setEditItem({_type: pTypes.plotOccupant})}>
                                    <UserPlusIcon className="w-6 mr-2" />
                                    <span>Add Grave</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                    <hr className="mt-8 mb-4 border-black" />
                    {/* <MapEditorPeopleOccupied _id={plotId} onError={onError} onChange={state=>setIsOccupied(state)} /> */}
                    <h4 className='font-bold mb-4'>Owners</h4>
                    <ul className="block">
                        {plotOwners && plotOwners.length > 0 && plotOwners.map(item=>(
                            <li className="block mb-4" key={item._id}>
                                {(canEditPlots && (
                                    <button className="btn-invert w-full p-4" onClick={()=>setEditItem({...item, _type: pTypes.plotOwner})}>
                                        <MapEditorPerson _id={item._id} plotId={plotId} />
                                    </button>
                                )) || (
                                    <div className="w-full p-4">
                                        <MapEditorPerson _id={item._id} plotId={plotId} />
                                    </div>
                                )}
                            </li>
                        ))}
                        {(canEditPlots && (
                            <li className="block mb-4">
                                <button className="btn flex w-full p-4" onClick={()=>setEditItem({_type: pTypes.plotOwner})}>
                                    <UserPlusIcon className="w-6 mr-2" />
                                    <span>Add Owner</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                    {(canEditPlots && (
                        <MapEditorDateEditor _id={plotId} />
                    )) || (
                        <div>
                            <h5 className="font-bold">Purchase Date</h5>
                            <p className="p-4">{details && details.date || 'No date on file'}</p>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}